import { useRef, useState } from "react";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";

export default function VendorsFilter({ filterDataHandler }) {
  const userModalRef = useRef();

  const [user, setUser] = useState(null);
  const { utils } = useSelector(utilsState);

  const deleteUser = () => {
    setUser(null);
    filterDataHandler({ page: 1, user: "" });
  };

  const handleUser = (data) => {
    setUser(data);
    filterDataHandler({ page: 1, user: data?._id });
  };

  return (
    <>
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
        <div className="admin-filter-grid">
          <div className="w-full min-w-0">
            <div class="max-w-md mx-auto">
              <div class="relative">
                <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                  <svg
                    class="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <input
                  onChange={(e) =>
                    filterDataHandler({ page: 1, name: e.target.value })
                  }
                  type="search"
                  className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="جست و جو غرفه ..."
                  required
                />
              </div>
            </div>
          </div>
          <div className="relative">
            <span
              onClick={() => userModalRef?.current?.showModal()}
              className="absolute w-full h-full"
            ></span>
            {user ? (
              <PiXFill
                className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
                onClick={deleteUser}
              />
            ) : null}
            <input
              value={user?.name || user?.mobile || "انتخاب کاربر"}
              disabled
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="w-full min-w-0">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, selectedBooth: e.target.value })
              }
              id="province"
              className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value={""} selected>
                غرفه منتخب
              </option>
              <option value={"1"}>بله</option>;<option value={"0"}>خیر</option>;
            </select>
          </div>
          <div className="w-full min-w-0">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, status: e.target.value })
              }
              id="province"
              className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value={""} selected>
                غرفه منتخب
              </option>
              <option value={"1"}>بله</option>;<option value={"0"}>خیر</option>;
            </select>
          </div>
          <div className="w-full min-w-0">
            <select
              onChange={(e) =>
                filterDataHandler({ page: 1, status: e.target.value })
              }
              id="province"
              className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value={""} selected>
                وضعیت
              </option>
              {utils
                ? utils.VENDOR_STATUS_VALUES.map((item) => {
                    return <option value={item.value}>{item?.name}</option>;
                  })
                : null}
            </select>
          </div>
        </div>
      </div>
    </>
  );
}
